import React from "react";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import { useControlBarDashboardSetupButtonHook } from "./use-control-bar-dashboard-setup-button-hook";
import { useI18N } from "@src/language/language-context";

export const ControlBarDashboardSetupButton = () => {
  const { icon, disabled, openDashboardSetupDrawer } =
    useControlBarDashboardSetupButtonHook();
  const i18n = useI18N();
  const tooltip = i18n(
    "modules.machineStructurePanelControlBar.openBlueprintDashboardSetup",
  );

  return (
    <IconButton
      key={tooltip}
      tooltip={tooltip}
      tooltipPosition="bottom"
      fun={openDashboardSetupDrawer}
      icon={icon}
      disabled={disabled}
    />
  );
};
